import React from 'react';
import { AIFooter } from '../private/components/AIFooter';

export const SlAIFooter = () => {
  return <AIFooter />;
};